var map = {
	"./lang0.mp3": 1939,
	"./lang1.mp3": 1940,
	"./lang10.mp3": 1941,
	"./lang11.mp3": 1942,
	"./lang12.mp3": 1943,
	"./lang13.mp3": 1944,
	"./lang2.mp3": 1945,
	"./lang3.mp3": 1946,
	"./lang4.mp3": 1947,
	"./lang5.mp3": 1948,
	"./lang6.mp3": 1949,
	"./lang7.mp3": 1950,
	"./lang8.mp3": 1951,
	"./lang9.mp3": 1952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1938;